import type { AgreementStates } from "../types";

type AgreementHiddenKey = `${keyof AgreementStates}Hidden`;
type AgreementRequireKey = `${keyof AgreementStates}Required`;

type AgreementStatesStatuses = Record<AgreementHiddenKey | AgreementRequireKey, boolean>;

export const getAgreementsStates = (agreementStates: Partial<AgreementStates>) =>
  Object.entries(agreementStates).reduce<AgreementStatesStatuses>(
    (acc, [key, value]) => {
      return {
        ...acc,
        [`${key}Hidden` as AgreementHiddenKey]: value === "hidden",
        [`${key}Required` as AgreementRequireKey]: value === "required",
      };
    },
    {
      acceptGroupActionHidden: false,
      acceptGroupActionRequired: false,
      marketingPhoneContactHidden: false,
      marketingPhoneContactRequired: false,
      newsletterHidden: false,
      newsletterRequired: false,
    },
  );
